/**
 * @generated SignedSource<<aab4b78488ea1136fad3b232299f2480>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NavigationTeamButton_project$data = {
  readonly id: string;
  readonly teamsConnected: {
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "NavigationTeamButton_project";
};
export type NavigationTeamButton_project$key = {
  readonly " $data"?: NavigationTeamButton_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationTeamButton_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NavigationTeamButton_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
      "kind": "LinkedField",
      "name": "teamsConnected",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "totalCount"
          },
          "action": "THROW",
          "path": "teamsConnected.totalCount"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "38f5e9f2f6e8947927d83ba5f7faea64";

export default node;
